import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Input, Text, ErrorMsg } from "@fragments";
import { TuneRounded } from "@mui/icons-material";

import {
    AssetCategory,
    CommunityAssetImageField,
} from "@features/uploadAsset";

export default function General({
    configRef,
    communityId,
    onUploadingChange,
    errors = {},
    clearError = () => {},
}) {
    const { t } = useTranslation("groupModals");
    const [banner, setBanner] = useState(configRef.current.banner || null);

    function handleBannerChange(url) {
        configRef.current.banner = url;
        setBanner(url);
    }

    return (
        <>
            <div className="banner-add mt-2">
                <CommunityAssetImageField
                    communityId={communityId}
                    category={AssetCategory.GROUP_BANNER}
                    value={banner}
                    onChange={handleBannerChange}
                    onUploadingChange={onUploadingChange}
                    aspectRatio={1}
                    size={92}
                    imageMaxWidth={720}
                    title={t("manageGroup.general.bannerTitle")}
                    displayTitle={false}
                />
            </div>

            <Text.h3
                left={<TuneRounded />}
                value={t("manageGroup.general.title")}
                className="mt-2 mb-1"
            />

            <Input.Text
                placeholder={t("manageGroup.general.namePlaceholder")}
                value={configRef.current.name}
                onInput={(v) => {
                    configRef.current.name = v;
                    if (errors?.name) clearError("name");
                }}
                label={t("manageGroup.general.nameLabel")}
                size={25}
                error={!!errors?.name}
            />
            {errors?.name && <ErrorMsg>{errors.name}</ErrorMsg>}

            <Input.Text
                className="mt-2"
                placeholder={t("manageGroup.general.descriptionPlaceholder")}
                value={configRef.current.description}
                onInput={(v) => {
                    configRef.current.description = v;
                }}
                emoji
                multiline
                label={t("manageGroup.general.descriptionLabel")}
                size={250}
            />
        </>
    );
}
